import React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import theme from "../../../theme/Theme";

const TopReasons = () => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Typography sx={styles.sectionTitle}>
          Top Reasons Influencers{" "}
          <span style={styles.titleHighLight}>Love This Program</span>
        </Typography>
        <Grid container spacing={3} sx={styles.reasonsGrid}>
          {reasons.map((reason, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={styles.reasonCard}>
                <CardContent sx={styles.reasonCardContent}>
                  <Typography sx={styles.reasonIcon}>{reason.icon}</Typography>
                  <Box>
                    <Typography sx={styles.reasonTitle}>
                      {reason.title}
                    </Typography>
                    <Typography sx={styles.reasonDescription}>
                      {reason.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

const reasons = [
  {
    icon: "⚡",
    title: "Instant USDT payouts",
    description: "no waiting, no tokens",
  },
  {
    icon: "📈",
    title: "5-Level referral system",
    description: "for exponential earnings",
  },
  {
    icon: "🔗",
    title: " One click = lifetime referral",
    // description: "Start earning with just one click",
  },
  {
    icon: "💰",
    title: "No investment required",
    // description: "No upfront costs, pure profit",
  },
  {
    icon: "🔒",
    title: "Fully on-chain & transparent — zero scam risk",
    // description: "",
  },
  {
    icon: "📊",
    title: "Dashboard to track",
    description: "your commissions in real time",
  },
];

const styles = {
  section: {
    padding: { xs: "60px 0", md: "100px 0" },
    position: "relative",
  },
  sectionTitle: {
    fontWeight: "800",
    margin: "0.2em 2em 1em 1em",
    fontSize: { xs: "5.5vw", lg: "2.5vw" },
    textAlign: "center",
    color: theme.custom.black,
    textTransform: "uppercase",
    zIndex: 99,
  },
  titleHighLight: {
    color: theme.palette.primary.main,
    borderBottom: "1.5px solid rgba(0, 0, 0, 1)",
  },
  reasonCard: {
    height: "100%",
    border: "none",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
    },
  },
  reasonCardContent: {
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "16px",
  },
  reasonIcon: {
    fontSize: "2.5rem",
    marginBottom: "12px",
  },
  reasonTitle: {
    fontSize: "1.3rem",
    fontWeight: 600,
    marginBottom: "8px",
    color: theme.palette.primary.main,
  },
  reasonDescription: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
  },
};

export default TopReasons;
